import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import NOIBox from "./NOIBox";

import { npvTotalData } from "../../sample";
import { noiEndPoints } from "../../../../services/apiEndPoints";
import { currencyFormatter } from "../../../../services/utils";
import { getData } from "../../../../services/api";

const NpvPowerRevenue = ({ filtervalue, handleChange, value }) => {
  const [npvTotal, setNpvTotal] = useState(npvTotalData);
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);
  const { period, startDate, endDate } = useSelector((state) => state.selectedPeriods);

  useEffect(() => {
    const dateQueryParams = {
      period,
      startDate,
      endDate,
    };
    if (filtervalue) {
      getData(
        noiEndPoints.NPV_TOTAL,
        (data) => {
          setNpvTotalPowerRevenue(data, filtervalue);
        },
        { discount_rate: filtervalue, ...dateQueryParams }
      );
    }
  }, [period, startDate, endDate, filtervalue]);

  const setNpvTotalPowerRevenue = (nvpData, exitingParameter) => {
    setNpvTotal((prevState) => {
      return {
        ...prevState,
        chartData: {
          data: [{ NPV_of_power_revenue: nvpData.results }],
          fields: prevState.chartData.fields,
        },
        rows: prevState.rows.map((val) => {
          if (val.key === "discount_rate") {
            return {
              ...val,
              value: exitingParameter,
            };
          } else if (val.key === "npv_power_revenue") {
            return {
              ...val,
              value: currencyFormatter(nvpData.results, currencySymbol),
            };
          }
        }),
      };
    });
  };

  return <NOIBox item={npvTotal} filtervalue={value} handleChange={handleChange} />;
};

export default NpvPowerRevenue;
